import { useIntl } from 'react-intl'

import Stack from 'app/components/base/Stack'
import ShareButton from 'app/components/buttons/ShareButton'
import CreatedAt from 'app/features/Blog/components/CreatedAt'

interface ArticleHeaderProps {
  createdAt: string | number | Date
  shareLink: string
  media: string[]
}

const ArticleHeader: RFC<ArticleHeaderProps> = ({
  createdAt,
  shareLink,
  media
}) => {
  const intl = useIntl()

  const shareButtonTitle = intl.formatMessage({
    defaultMessage: 'Share this article'
  })

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <CreatedAt date={createdAt} />

      <ShareButton
        url={shareLink}
        media={media}
        listingTitle={shareButtonTitle}
        sx={{ mt: 0 }}
      />
    </Stack>
  )
}

export default ArticleHeader
